/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

//import context
import { GlobalProvider } from "context/GlobalContext";
import { useTranslation } from "react-i18next";

const SaveModuleRolePopup = ({
  moduleList,
  afterPopupCLose,
  moduleRoleId,
  setModuleRoleId,
}) => {
  const token = localStorage.getItem("token"); // token
  const { t } = useTranslation(); //for translation

  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");

  const [moduleValue, setmoduleValue] = useState(null);
  const [selectedModule, setselectedModule] = useState(null);

  const [isSaving, setIsSaving] = useState(false);

  /* hook for validation */
  const [errors, setErrors] = useState({});

  /* function to validate form */
  const validate = () => {
    const newErrors = {};

    if (name.trim() === "") {
      newErrors.name = t("Module role title is required.");
    }

    if (slug.trim() === "") {
      newErrors.slug = t("A unique slug is required for the module role.");
    }

    if (moduleValue === null) {
      newErrors.module = t(
        "Please choose a module to associate with this role."
      );
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //select module
  const moduleSectionHandler = (val) => {
    if (val) {
      setmoduleValue(val);
      setselectedModule(val.value);

      if (name !== "") {
        setSlug(`${val.slug}_${name === "" ? "" : name.toUpperCase()}`);
      }
    } else {
      setmoduleValue(null);
      setselectedModule(null);
    }
  };

  //get details
  const getDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_MODULE_ROLE_DETAILS +
        `/${moduleRoleId}` +
        ``;

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status) {
        setName(response.data.name);
        setSlug(response.data.slug);
        moduleSectionHandler(response.data.moduledata);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for create new tag
  const saveHandler = async () => {
    if (!validate()) {
      return;
    }
    setIsSaving(true);
    try {
      let sendingData = {
        name,
        slug,
        module: selectedModule,
      };

      let requestUrl = url.API_BASE_URL;

      let response = {};

      if (moduleRoleId) {
        requestUrl =
          requestUrl +
          url.API_UPDATE_MODULE_ROLE +
          `/${moduleRoleId}` +
          ``;

        response = await putData(requestUrl, sendingData);
      } else {
        requestUrl =
          requestUrl + url.API_CREATE_MODULE_ROLE;

        response = await postData(requestUrl, sendingData);
      }

      setIsSaving(false);

      console.log(response);

      if (response.status) {
        // close the modal of addLabel
        bootstrap.Offcanvas.getInstance(
          document.querySelector("#saveModuleRole")
        ).hide();
        resetHandler();
        afterPopupCLose([response.data]);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  /* reset */
  const resetHandler = () => {
    setName("");
    setSlug("");
    setmoduleValue(null);
    setselectedModule(null);
    setModuleRoleId(null);
    setErrors({});
  };

  useEffect(() => {
    if (moduleRoleId) {
      getDetails();
    }
  }, [moduleRoleId]);

  const customStyle = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.module ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.module ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
  };

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="saveModuleRole"
      aria-labelledby="saveModuleRole"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              category
            </span>{" "}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasLabelDetailsLabel"
            >
              {moduleRoleId ? t("Edit Module Role") : t("Create Module Role")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {moduleRoleId
                ? t("Manage existing module role details")
                : t("Define a new module role")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4 pt-5">
        <div className="p-4 pb-5 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="fields-container flex-fill">
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="labelName"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Title")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="labelName"
                  className={`form-control fs-sm shadow-none ${
                    errors.name ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., Content Manager")}
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    if (errors.name) {
                      setErrors((prev) => ({ ...prev, name: "" }));
                    }
                  }}
                  aria-describedby="titleFeedback"
                />
                {errors.name && (
                  <div id="titleFeedback" className="invalid-feedback">
                    {errors.name}
                  </div>
                )}
              </div>

              {/* slug */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="slugID"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Slug")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="slug"
                  className={`form-control fs-sm shadow-none ${
                    errors.slug ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., content_manager")}
                  value={slug}
                  onChange={(e) => {
                    setSlug(e.target.value);
                    if (errors.slug) {
                      setErrors((prev) => ({ ...prev, slug: "" }));
                    }
                  }}
                  aria-describedby="slugFeedback"
                />
                {errors.slug && (
                  <div id="slugFeedback" className="invalid-feedback">
                    {errors.slug}
                  </div>
                )}
              </div>

              {/* module */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="moduleSelect" // Unique ID for accessibility
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Select Module")} <span className="text-danger">*</span>
                </label>
                <Select
                  inputId="moduleSelect" // Connects label to the Select input
                  placeholder={t(
                    "Choose a module to associate with this role..."
                  )}
                  isClearable
                  options={moduleList}
                  value={moduleValue}
                  onChange={(val) => moduleSectionHandler(val)}
                  styles={customStyle} // Apply the custom styles
                  aria-describedby="moduleFeedback"
                  menuPlacement="top"
                />
                {errors.module && (
                  <div id="moduleFeedback" className="invalid-feedback d-block">
                    {errors.module}
                  </div>
                )}
              </div>
            </div>
            <div className="action d-flex justify-content-end pt-4 border-top mt-auto">
              <button
                onClick={saveHandler}
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isSaving ? true : false}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Saving...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Save Module Role")}
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SaveModuleRolePopup;
